<div class="page-wrapper">
  <div data-collapse="medium" data-animation="default" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="navbar-landing w-nav">
    <div class="container-m container-navbar">
      <div class="navbar-brand-wrapper">
        <a href="#" class="navbar-brand w-nav-brand"><img src="../../assets/images/Gruppe-694.svg" loading="lazy" width="158" alt="Hudson Logo" class="brand-image-white"></a>
      </div>
    </div>
    <div class="bg-section bg-nav-landing"></div>
  </div>
  <header class="header-auto home">
    <div class="container-l">
  
      <div class="w-layout-grid grid _2er-header-lp-1">
        <div id="w-node-_522ffd75-2e38-4429-3837-75f03dd38405-ebed0b04" class="grid-item">
          <div data-w-id="522ffd75-2e38-4429-3837-75f03dd38406" class="topline-wrapper b-lp">
            <div class="topline-line bg-background home-header"></div>
            <div class="text-topline text-background">{{campaign.developerName}}</div>
          </div>
          <div class="text-animation-wrapper">
            <div data-w-id="522ffd75-2e38-4429-3837-75f03dd3840b" class="h1-lp text-background">{{campaign.campaignTitle}}</div>
          </div>
          <div>
            <h5 class="h-caps text-background" style="letter-spacing: 0.3em;">{{campaign.basicDescription}}</h5>
          </div>
        </div>
        <div class="grid-item" style="margin-top: 100px;">
          <div data-w-id="8d2947b4-3379-efad-6f95-ba38bab4f427" style="padding: 30px;"  class="form-box bg-light">
            <div class="content-wrapper i-80px">
              <h4 class="h4">Contact Sales</h4>
            </div>
            <div class="form-block-normal t-10px w-form">
              <div class="html-embed w-embed">
              </div>
              <!-- <form method="post" data-name="Contact" id="wf-form-Contact" name="wf-form-Contact" class="form" data-wf-page-id="615ea8ddc2e6612f62a9927d" data-wf-element-id="8d2947b4-3379-efad-6f95-ba38bab4f42d"> -->
                <div class="w-layout-grid grid _2er-form-demo" *ngIf="!isContactSubmitted">
                  <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f42f-62a9927d" class="grid-item"><input style="padding: 0.6em;" class="input w-input" maxlength="256" name="First-Name" data-name="First Name" placeholder="First name" type="text" id="First_name" required [(ngModel)]="inquiryData.customerDetails.firstName"></div>
                  <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f431-62a9927d" class="grid-item"><input style="padding: 0.6em;" class="input w-input" maxlength="256" name="Last-Name-2" data-name="Last Name 2" placeholder="Last Name" type="text" id="Last-Name-2" [(ngModel)]="inquiryData.customerDetails.lastName"></div>
                  <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f433-62a9927d" class="grid-item"><input style="padding: 0.6em;" class="input w-input" maxlength="256" name="Email-2" data-name="Email 2" placeholder="Email" type="email" id="Email-2" [(ngModel)]="inquiryData.customerDetails.email"></div>
                  <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f435-62a9927d" class="grid-item"><input style="padding: 0.6em;" class="input w-input" maxlength="256" name="Phone-2" data-name="Phone 2" placeholder="Phone" type="tel" id="Phone-2" [(ngModel)]="inquiryData.customerDetails.phoneNo"></div>
                  <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f437-62a9927d" class="grid-item"><textarea style="padding: 0.6em;" placeholder="Message" maxlength="5000" id="field-2" name="field-2" data-name="Field 2" class="text-area w-input" [(ngModel)]="inquiryData.propertyDetails.inquiryDetail"></textarea></div>
                  <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f439-62a9927d" class="grid-item"><label class="w-checkbox checkbox-label t-10px"><input type="checkbox" id="checkbox-2" name="checkbox-2" data-name="Checkbox 2" [(ngModel)]="isAgreeTermServiceCheck" class="w-checkbox-input checkbox-hudson"><span class="text-xsmall text-default w-form-label" for="checkbox-2">I agree to the Terms of Service and Privacy Policy</span></label></div>
                  <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f43e-62a9927d" class="grid-item">
                    <button [ngClass]="{'btn-disable':!isContactFormValid()}" (click)="savePropertyInquiry()" class="button button-primary button-full-width button-form w-button">Connect with us</button>
                  </div>
                </div>
              <!-- </form> -->
              <div class="form__success" *ngIf="isContactSubmitted" style="padding-top: 20px;">
                <div class="h3">Thank you!</div>
                <p class="text-big">We have received your request and will process it as soon as possible.</p>
              </div>
              <div class="form__error w-form-fail">
                <div class="form__error-bg"></div>
                <div class="form__error-text">Oops! Something went wrong while submitting the form.</div>
              </div>
            </div>
          </div>
      </div>
      </div>
    </div>
    <div class="bg-section bg-dark"><img src="{{campaign.titleMediaUri}}" loading="lazy" sizes="100vw" alt="" class="image full-screen trans-50"></div>
  </header>
  <section class="section standard">
    <div class="container-m" style="margin-top: 50px;">
      <div class="orga">
        <div class="w-layout-grid grid _2er-c-normal">
          <div id="w-node-_54ceb0a3-5c0e-c086-3ce7-bf95caeb2834-e0a99293" class="grid-item">
            <div data-w-id="522ffd75-2e38-4429-3837-75f03dd3844a" class="topline-wrapper b-30px">
              <div class="topline-line bg-primary"></div>
              <div class="text-topline">Property description</div>
              
            </div>
            <div class="content-wrapper">
              <h2 data-w-id="522ffd75-2e38-4429-3837-75f03dd38451" class="h2">{{campaign.campaignTitle}}</h2>
            </div>
            <div data-w-id="91666168-a8a2-2aa8-aef6-58ccc1dd1aaf"  class="image-wrapper"><img src="{{campaign.descriptionMediaUri}}" loading="lazy" width="742" sizes="(max-width: 479px) 87vw, (max-width: 991px) 88vw, 742px" alt=""  class="image-services"></div>
          </div>
          <div class="grid-item" style="margin-top: 50px;">
            <div class="content-wrapper">
              <div data-w-id="390c7474-cc3e-701e-6198-4d96f46a9a12"  class="topline-wrapper b-20px">
                <div data-w-id="b62fcfed-8835-44b8-2992-cd09ebf39fa1" class="w-richtext" [innerHTML]="campaign.description"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-w-id="522ffd75-2e38-4429-3837-75f03dd3845c" class="linie space-introduction"></div>
      <div class="orga">
        <div class="w-layout-grid grid _2er-c-normal">
          <div id="w-node-_54ceb0a3-5c0e-c086-3ce7-bf95caeb2834-e0a99293" class="grid-item">
            <div data-w-id="522ffd75-2e38-4429-3837-75f03dd3844a" class="topline-wrapper b-30px">
              <div class="topline-line bg-primary"></div>
              <div class="text-topline">Unit & Price</div>
              
            </div>
            <div class="content-wrapper">
              <h2 data-w-id="522ffd75-2e38-4429-3837-75f03dd38451" class="h2">{{campaign.campaignTitle}}</h2>
            </div>
            <div data-w-id="91666168-a8a2-2aa8-aef6-58ccc1dd1aaf"  class="image-wrapper"><img src="{{campaign.unitMediaUri}}" loading="lazy" width="742" sizes="(max-width: 479px) 87vw, (max-width: 991px) 88vw, 742px" alt=""  class="image-services"></div>
          </div>
          <div class="grid-item" style="margin-top: 50px;">
            <div class="content-wrapper">
              <div data-w-id="390c7474-cc3e-701e-6198-4d96f46a9a12"  class="topline-wrapper b-20px">
                <div data-w-id="b62fcfed-8835-44b8-2992-cd09ebf39fa1" class="w-richtext" [innerHTML]="campaign.unitDescription"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div data-w-id="522ffd75-2e38-4429-3837-75f03dd3845c" class="linie space-introduction"></div>
      <div class="w-layout-grid grid _3er-facts-lp t-40px">
        <div id="w-node-_2cf8cb5b-0f3a-1169-1fa3-0216b6026551-ebed0b04" class="grid-item">
          <div class="content-flex-inner">
            <div class="content-wrapper l-15px">
              <div class="text-highlight-zusatz m-center">Booking</div>
              <div class="text-landing-details">{{campaign.bookingAmount}}</div>
            </div>
          </div>
        </div>
        <div id="w-node-_2cf8cb5b-0f3a-1169-1fa3-0216b6026558-ebed0b04" class="grid-item">
          <div class="content-flex-inner">
            <div class="content-wrapper">
              <div class="text-highlight-zusatz m-center">Payment Plan</div>
              <div class="text-landing-details">{{campaign.paymentPlan}}</div>
            </div>
          </div>
        </div>
        <div id="w-node-_2cf8cb5b-0f3a-1169-1fa3-0216b602655f-ebed0b04" class="grid-item">
          <div class="content-flex-inner">
            <div class="content-wrapper">
              <div class="text-highlight-zusatz m-center">Handover</div>
              <div class="text-landing-details">{{campaign.handover}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-background"></div>
  </section>
  <section class="section standard t-50px">
    <div class="container-m">
        <a (click)="openImageDialog()" style="cursor: pointer;" class="image title-image w-inline-block w-lightbox"><img alt="" loading="lazy" width="1267" src="{{propertyTitleImageUri}}" class="image title-image"/>
            <div class="image-button"><img src="{{propertyTitleImageUri}}" loading="lazy" width="34" alt="" class="image-button-icon">
              <div>All images</div>
            </div>
          </a>
        
    </div>
 </section>
  <section class="section standard no-overflow">
    <div class="container-m">
      <div class="content-wrapper">
        <div data-w-id="522ffd75-2e38-4429-3837-75f03dd3853a"   class="topline-wrapper b-30px c-center">
          <div class="text-topline">COntact</div>
          <div class="topline-line bg-primary c-center"></div>
        </div>
        <h4 data-w-id="522ffd75-2e38-4429-3837-75f03dd3853e"   class="h2 l-center"><strong>GET IN TOUCH </strong></h4>
        <p data-w-id="522ffd75-2e38-4429-3837-75f03dd38541"   class="text-normal max-lp">Contact our real estate experts to discuss your needs. Our team has the expertise to guide you through the entire process.<br></p>
        <div data-w-id="522ffd75-2e38-4429-3837-75f03dd38544"   class="button-wrapper t-30px l-center">
          <a [routerLink]="['/contact']" class="button button-primary w-button">contact us</a>
        </div>
      </div>
    </div>
    <div class="bg-section bg-light"></div>
  </section>
  <footer class="footer-lp">
    <div class="container-l">
      <div class="w-layout-grid grid _3er-footer-lp">
        <div id="w-node-_1ae7fee4-0ac5-9347-7f1b-673e5b571767-5b571742" class="grid-item">
          <div class="text-xsmall">©2025 Hudson Real Estate LLC.</div>
        </div>
        <div id="w-node-_1ae7fee4-0ac5-9347-7f1b-673e5b57176a-5b571742" class="grid-item">
          <div class="footer-brand-wrapper">
            <a href="#" class="footer-brand w-nav-brand"><img src="../../assets/images/hudson-icon.svg" loading="lazy" width="150" alt="" class="brand-image-footer"></a>
          </div>
        </div>
        <div id="w-node-_1ae7fee4-0ac5-9347-7f1b-673e5b57176e-5b571742" class="grid-item">
          <div class="privacy-link-wrapper">
            <a [routerLink]="['/terms-condition']" class="link-footer inline first">Terms &amp; Conditions</a>
            <a [routerLink]="['/privacy']" class="link-footer inline">Privacy Policy</a>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-background"></div>
  </footer>
</div>

